import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// PostHog analytics
;
(function () {
  var ph = (window as any).posthog;
  if (ph && ph.__loaded) return;
  (window as any).posthog = ph = Object.assign(function (...args: any[]) {
    ph.q = ph.q || [];
    ph.q.push(args);
  }, {
    q: [] as any[]
  });
  ph.init = function (token: string, config: any) {
    ph._i = ph._i || [];
    ph._i.push([token, config]);
    ph._token = token;
  };
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://eu-assets.i.posthog.com/static/array.js';
  var firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode!.insertBefore(script, firstScript);
})();
(window as any).posthog.init('phc_MPi2KNx5eDM8HPzxYZkq70CH9zpB64lsMUUwArafcHa', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only'
});
render(<App data-id="element-68" />, document.getElementById('root'));